export default {
  namespaced: true,
  state: {
    id: 0,
    name: '',
    menuCodeSet: [], // 管理权限页面
    menuList: []
  },
  mutations: {
    updateId(state, id) {
      state.id = id
    },
    updateName(state, name) {
      state.name = name
    },
    updateMenuCodeSet(state, menuCodeSet) {
      state.menuCodeSet = menuCodeSet
    },
    SET_MENU(state, menuList) {
      state.menuList = menuList
    }
  }
}
